<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Répartition des motifs non conforme</strong>
      </b-card-header>
      <b-card-body>
        <label><strong><u>Nombre de dossiers contrôlés</u> : {{nbDossiersTraites}}</strong> (dont {{nbDossierAbandonnes}} abandonnés)</label><br><br>
        <v-client-table :columns="columns" :data="data" :options="options">
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="returnToDetailPage()" class="pull-left ml-1 mr-1 mt-1" size="md" variant="primary">
          Retour campagne
        </b-button>
      </div>
    </b-card>

  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "MotifsNonConforme",
    data() {
      return {
        id: null,
        columns: ['libelle','groupe_dossier_type', 'total'],
        data: [],
        nbDossiersControles: '',
        nbDossiersTraites: '',
        nbDossierAbandonnes: '',
        options: {
          headings: {
            'libelle': 'Libellé motif',
            'groupe_dossier_type': 'Type dossier',
            'total': 'Total',
          },
          filterable: false,
          perPage: 10,
          perPageValues: [10, 25, 50],
          orderBy: {column: 'id', ascending: false}
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.id = this.$route.params.id;
      this.getMotifsNonConforme();
      this.getStats()
    },
    methods: {
      getMotifsNonConforme() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/campagnes/motifs-non-conforme/" + this.id)
          .then(response => {
            this.data = response.data.data;
            this.nbDossiersControles = response.data.nbDossiersControles
          })
          .catch((error) => {
            console.log('error : ', error);

          })
          .finally(() => this.$store.commit('IS_LOADING', false));
      },
      returnToDetailPage() {
        this.$router.push({path: '/espace-qualite/campagnes/detail/' + this.id});
      },
      getStats() {
        this.$store.commit('IS_LOADING', true);
          this.$axios
            .get("/espaceQualite/campagnes/stats/" + this.id)
            .then(response => {
              this.nbDossiersTraites = response.data.data.nbr_dossiers_traites;
              this.nbDossierAbandonnes = response.data.data.nbr_dossiers_abandonnes;
            })
            .catch(() => {
              this.$store.commit('IS_LOADING', false);
              this.displayErrorModal('Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI');
            });
      }
    }
  }
</script>
